var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"6 9 12 15 18 9"}));
}

ChevronInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"#1C1A33","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-chevron-down"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
